import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

/**
 * Subtitle Props
 * @property {Node} children - children, which commonly include the subtitle text and a help link.
 * @property {Object} className - additional class names for title
*/

export function Subtitle(props) {
  const {
    children, className,
  } = props;

  return (
    <div className={classNames('page-status', 'row', 'type5', 'page-subtitle-container', className)}>
      <h3 className="col-sm-12">{children}</h3>
    </div>
  );
}

Subtitle.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
  className: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.array,
    PropTypes.object,
  ]),
};

Subtitle.defaultProps = {
  className: '',
};
